var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaultfirstlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 47,
    viewBox: "0 0 43 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90783 41.6482C-1.65508 33.0378 -2.70949 11.1204 9.90783 2.24907C22.5251 -6.62228 35.9267 12.4248 41.7056 30.1677C47.4845 47.9105 21.4707 50.2585 9.90783 41.6482Z",
    fill: "#C8DAF4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip99999999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3958 22.4286H4.60417C2.64816 22.4286 1.0625 24.2601 1.0625 26.5195V40.8376C1.0625 43.097 2.64816 44.9286 4.60417 44.9286H29.3958C31.3518 44.9286 32.9375 43.097 32.9375 40.8376V26.5195C32.9375 24.2601 31.3518 22.4286 29.3958 22.4286Z",
    stroke: "#0056CD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37555 21.9375V13.5447C6.37555 10.7623 7.44832 8.09381 9.35787 6.12635C11.2674 4.1589 13.8573 3.05359 16.5578 3.05359C19.2584 3.05359 21.8483 4.1589 23.7578 6.12635C25.6674 8.09381 26.7401 10.7623 26.7401 13.5447V21.9375",
    stroke: "#0056CD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99999999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 45,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultfirstlock);
export default __webpack_public_path__ + "static/media/vaultfirstlock.2edf783a.svg";
export { ForwardRef as ReactComponent };